<template>
  <div>
    <h3 style="text-align: left;padding-bottom: 30px;">基本信息</h3>
    <el-form ref="form" :model="form" label-width="100px" style="text-align: left">
      <el-form-item label="开馆状态">
        <el-switch v-model="form.state"></el-switch>
      </el-form-item>
      <el-form-item label="强制开馆">
        <el-switch v-model="form.forcestate"></el-switch>
      </el-form-item>
      <el-form-item label="闭馆原因" v-if="form.state == 0">

        <el-input  placeholder="请输入内容" v-model="form.closereason" style="width:315px;" ></el-input>
      </el-form-item>
      <el-form-item label="开放季节">
        <el-select v-model="form.season" placeholder="请选择当前季节">
          <el-option label="冬季" value="冬季"></el-option>
          <el-option label="夏季" value="夏季"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开馆时间">
        <el-col :span="5">
          <el-input  placeholder="请输入内容" v-model="form.date1" style="width:315px;" ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="停止入馆时间" >
        <el-col :span="5">
          <el-input  placeholder="请输入内容" v-model="form.date2" style="width:315px;" ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="闭馆时间">
        <el-col :span="5">
          <el-input  placeholder="请输入内容" v-model="form.date3" style="width:315px;" ></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="服务电话" >
        <el-input v-model="form.phone" style="width:315px;" ></el-input>
      </el-form-item>
      <el-form-item label="温馨提示">
        <el-input type="textarea" v-model="form.abstr"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">确定</el-button>
<!--        <el-button>取消</el-button>-->
      </el-form-item>
    </el-form>


  </div>
</template>

<script>
import {request} from "@/request/request";

export default {
  name: "YjjAdmin",
  data() {
    return {
      form: {
        phone: '024-48889088',
        season: '',
        date1: '',
        date2: '',
        date3: '',
        state: '',
        forcestate: '',
        closereason:'设备检修，临时闭馆',
        abstr: '每周一至周五开馆，周六、周日闭馆，法定假日除外'
      },
      restfulUrl:'yjjstate',
    }
  },
  methods: {
    onSubmit() {
      console.log(this.form)
      if(this.form){
        if(this.form.state){
          this.form.state = 1;
          if(this.form.forcestate){
            this.form.forcestate = 1;
          }
          else{
            this.form.forcestate = 0;
          }
          this.updateOneById(this.form)
          this.getData();
        }
        else{
          this.form.state = 0;
          this.updateOneById(this.form)
          this.getData();
        }
      }

    },

    getData:function (){
      request({
        method:'GET',
        url:"/yjjstate",
      }).then(res =>{
        console.log(this.form)
        if(res.data[0].state == 1){
          this.form = res.data[0];
          this.form.state = true;

        }
        else if(res.data[0].state == 0){
          this.form = res.data[0];
          this.form.state = false;
        }

        if(res.data[0].forcestate == 1){

          this.form = res.data[0];
          this.form.forcestate = true;

        }
        else if(res.data[0].forcestate == 0){
          this.form = res.data[0];
          this.form.forcestate = false;
        }



      },err=>{
        console.log(err)
      })
    },

    updateOneById:function(data){
      request({
        method:'PUT',
        url:'/yjjstate',
        data:data
      }).then(res =>{
        if(res.code==1){
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
        }
      },err=>{
        console.log(err)
      })
    },
  },
  mounted() {
    this.getData();

  }
}
</script>

<style scoped>

</style>
